import { __assign, __awaiter, __generator, __rest } from "tslib";
import localforage from "localforage";
import { writable } from 'svelte/store';
export var savedStates = writable([]);
export var store = localforage.createInstance({
    name: "talapettige"
});
var formatData = function (data) {
    var play = data.play, sequence = data.sequence, talometer_options = data.talometer_options, _a = data.name, name = _a === void 0 ? null : _a;
    var talaVolume = talometer_options.talaVolume, tanpuraVolume = talometer_options.tanpuraVolume, rest = __rest(talometer_options, ["talaVolume", "tanpuraVolume"]);
    return { play: play, sequence: sequence, name: name, talometer_options: rest };
};
export var saveState = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var saveData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                saveData = formatData(data);
                return [4 /*yield*/, store.setItem(JSON.stringify(saveData), Date.now().toString())];
            case 1:
                _a.sent();
                return [4 /*yield*/, loadStates()];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var loadStates = function () { return __awaiter(void 0, void 0, void 0, function () {
    var keys, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, store.keys()];
            case 1:
                keys = _a.sent();
                return [4 /*yield*/, Promise.all(keys.map(function (key) { return __awaiter(void 0, void 0, void 0, function () {
                        var value;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, store.getItem(key)];
                                case 1:
                                    value = _a.sent();
                                    return [2 /*return*/, __assign({ timestamp: value }, JSON.parse(key))];
                            }
                        });
                    }); }))];
            case 2:
                data = _a.sent();
                savedStates.set(data.sort(function (a, b) { return (b.timestamp - a.timestamp); }));
                return [2 /*return*/];
        }
    });
}); };
export var deleteState = function (record) { return __awaiter(void 0, void 0, void 0, function () {
    var timestamp, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                timestamp = record.timestamp, data = __rest(record, ["timestamp"]);
                return [4 /*yield*/, store.removeItem(JSON.stringify(data))];
            case 1:
                _a.sent();
                return [4 /*yield*/, loadStates()];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
